"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_badge_1 = require("@saatva-bits/pattern-library.components.badge");
const pattern_library_components_picture_imgix_1 = require("@saatva-bits/pattern-library.components.picture-imgix");
const ProductImage_module_scss_1 = __importDefault(require("./ProductImage.module.scss"));
/**
 * Taken from detail modal module to not bump packages there
 *
 * The tweak here is for implementing the gallery easier and also for
 * allowing to choose if the image reacts to the buystack swatch selections or not
 * @param {object} props
 * @param {string} props.alt - Alt if image doesnt show up
 * @param {string} props.tag - Product tag string text
 * @param {string} props.filename - Filename of the image
 * @param {string} props.folder - Folder of the image
 * @param {string} props.dataSelector - Data selector of the image
 * @param {string} props.containerClasses - Class overrides for container
 * @param {string} props.imageClasses - class overrides for img element
 * @param {string} props.pictureClasses - class overrides for picture element
 * @param {string} props.IMGIX_URL - imgix domain url to retrieve image
 */
const ProductImage = ({ alt, tag, filename, folder, dataSelector, containerClasses, imageClasses, pictureClasses, IMGIX_URL, }) => {
    const containerClassnames = (0, classnames_1.default)(ProductImage_module_scss_1.default.imageContainer, containerClasses);
    const pictureClassnames = (0, classnames_1.default)(ProductImage_module_scss_1.default.imagePicture, pictureClasses);
    const imageClassnames = (0, classnames_1.default)(ProductImage_module_scss_1.default.image, imageClasses);
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerClassnames, children: [(0, jsx_runtime_1.jsx)(pattern_library_components_picture_imgix_1.Picture, { lazyLoad: true, alt: alt, folder: folder, name: filename, imgixDomain: IMGIX_URL, dataSelector: dataSelector, imageClassName: imageClassnames, className: pictureClassnames, prefixOverride: {
                    mobile: 'none',
                    tablet: 'none',
                    desktop: 'none'
                } }), tag && ((0, jsx_runtime_1.jsx)(pattern_library_components_badge_1.Badge, { text: tag }))] }));
};
ProductImage.propTypes = {
    IMGIX_URL: prop_types_1.default.string.isRequired,
    filename: prop_types_1.default.string.isRequired,
    folder: prop_types_1.default.string.isRequired,
    tag: prop_types_1.default.string,
    alt: prop_types_1.default.string,
    containerClasses: prop_types_1.default.string,
    imageClasses: prop_types_1.default.string,
    pictureClasses: prop_types_1.default.string
};
exports.default = ProductImage;
//# sourceMappingURL=ProductImage.js.map